import { Box, Container } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router';
import ForgotPasswordManualEntryForm from './ForgotPasswordManualEntryForm';
import { useEffect } from 'react';

export default function ForgotPasswordManualEntryScreen() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const email = searchParams.get('email') || '';

  useEffect(() => {
    if (!email) {
      navigate('/forgot-password');
    }
  }, [email, navigate]);

  if (!email) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Container>
        <Box display="flex" justifyContent="center">
          <Box width="100%" maxWidth={552}>
            <ForgotPasswordManualEntryForm email={email} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
